/**
 * API-сервис для облачных проектов Кубикон CAD (Месяц 9 плана KUBIKON_CAD_PLAN.md).
 * Бэкенд: storys-микросервис minecraftia-school, префикс /kubikon-cad/...
 *
 * (CAD-редактор лежит в robotehnick.ru как раздел школы, но БД-микросервис
 *  storys общий между minecraftia-school и robotehnick.)
 */
import axios from 'axios';
import { STORYS_addres } from './API';

const api = axios.create({
    baseURL: STORYS_addres,
    timeout: 30000,
});

api.interceptors.request.use((config) => {
    try {
        const token = localStorage.getItem('Authorization');
        if (token) {
            config.headers = config.headers || {};
            config.headers.Authorization = token;
        }
    } catch (_) { /* ignore */ }
    return config;
});


/** Создать новый проект.
 *  body: { user_id, title?, description?, document_data?, thumbnail? } */
export const createProject = (body) =>
    api.post('/kubikon-cad/projects', body);

/** Получить проект целиком (для открытия в редакторе). */
export const getProject = (projectId, userId) =>
    api.get(`/kubikon-cad/projects/${projectId}`, {
        params: { user_id: userId },
    });

/** Обновить проект (title/description/document_data/thumbnail). */
export const updateProject = (projectId, body) =>
    api.put(`/kubikon-cad/projects/${projectId}`, body);

/** Удалить проект. */
export const deleteProject = (projectId, userId) =>
    api.delete(`/kubikon-cad/projects/${projectId}`, {
        params: { user_id: userId },
    });

/** Список проектов пользователя (без document_data). */
export const listUserProjects = (userId) =>
    api.get(`/kubikon-cad/users/${userId}/projects`);


/* ===================== Социальное (лента, лайки, комментарии) ===================== */

/** Публичная лента. opts = { q?, sort?, limit?, offset? } */
export const getFeed = (opts = {}) =>
    api.get('/kubikon-cad/feed', { params: opts });

/** Toggle лайк на проект. */
export const toggleLike = (projectId, userId) =>
    api.post(`/kubikon-cad/projects/${projectId}/like`, { user_id: userId });

/** Поставлен ли лайк текущим юзером. */
export const getLikeStatus = (projectId, userId) =>
    api.get(`/kubikon-cad/projects/${projectId}/like-status`, {
        params: { user_id: userId },
    });

/** Список комментариев. */
export const getComments = (projectId) =>
    api.get(`/kubikon-cad/projects/${projectId}/comments`);

/** Добавить комментарий. */
export const addComment = (projectId, userId, text) =>
    api.post(`/kubikon-cad/projects/${projectId}/comments`, {
        user_id: userId, text,
    });

/** Удалить свой комментарий. */
export const deleteComment = (commentId, userId) =>
    api.delete(`/kubikon-cad/comments/${commentId}`, {
        params: { user_id: userId },
    });

/** Засчитать просмотр (один раз на пользователя). */
export const registerView = (projectId, userId) =>
    api.post(`/kubikon-cad/projects/${projectId}/view`, { user_id: userId });

/** Скопировать чужой публичный проект себе (fork). */
export const forkProject = (projectId, userId) =>
    api.post(`/kubikon-cad/projects/${projectId}/fork`, { user_id: userId });

/** Жалоба на проект. */
export const reportProject = (projectId, userId, reason) =>
    api.post(`/kubikon-cad/projects/${projectId}/report`, {
        user_id: userId, reason,
    });

/** Облегчённый preview (без document_data) — для карточки. */
export const getProjectPreview = (projectId, userId) =>
    api.get(`/kubikon-cad/projects/${projectId}/preview`, {
        params: { user_id: userId },
    });
